import React, { Component } from 'react';
import { reduxForm, reset } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { debounce } from 'lodash';

import { formatMessage } from '../../lib/intl';
import EmailField from '../signin/email-field';
import PasswordField from '../signin/password-field';
import GuestAccountField from '../signin/guest-account-field';

const FORM_NAME = 'signinModal';

const i18n = defineMessages({
  badEmail: {
    id: 'singinModal.errors.email',
    defaultMessage: 'Enter your email to sign in',
  },
  badPassword: {
    id: 'singinModal.errors.password',
    defaultMessage: 'Enter your password to sign in',
  },
  invalidToken: {
    id: 'singinModal.errors.invalidToken',
    defaultMessage: 'Invalid email or token',
  },
  unauthenticated: {
    id: 'singinModal.errors.unauthenticated',
    defaultMessage: 'Invalid e-mail or password.',
  },
});

class SigninModalForm extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);

    this.state = {
      email: null,
      password: null,
      error: null,
    };

    this.onEmailChange = debounce(this.onEmailChange.bind(this), 500);
  }

  get isGuestAccount() {
    return this.props.existence === 'guest';
  }

  onEmailChange(value) {
    this.setState({
      email: value,
      error: null,
    });

    this.props.onEmailChange(value);
  }

  onPasswordChange = (value) => {
    this.setState({
      password: value,
      error: null,
    });
  }

  onForgotClick = () => {
    this.props.onForgotClick()
  }

  onClickSendMagicLink = () => {
    this.props.onClickSendMagicLink(this.state.email)
      .then(() => {
        window.$('#signin').modal('hide');
      });
  }

  onSubmit = () => {
    this.props.onSignin(this.state.email, this.state.password)
      .catch(() => {
        this.props.onSubmitError(this.formatMessage(i18n.unauthenticated));
      });
  }

  renderPasswordField() {
    if (this.isGuestAccount) {
      return (
        <div>
          <GuestAccountField
            onClickHandler={this.onClickSendMagicLink}
          />
        </div>
      );
    }

    return (
      <div>
        <small className="mt-2 pull-right">
          <a
            tabIndex="-1"
            href="#password-reset"
            onClick={() => this.onForgotClick()}

          >
            <FormattedMessage
              id="singinModal.forgorPassword"
              defaultMessage="Forgot?"
            />
          </a>
        </small>
        <PasswordField
          onPasswordChange={this.onPasswordChange}
        />
      </div>
    );
  }

  renderSubmitButton() {
    if (this.isGuestAccount) return;

    return (
      <button type="submit" className="btn btn-primary full-width">
        <FormattedMessage
          id="singinModal.submitButton.label"
          defaultMessage="Sign in"
        />
      </button>
    );
  }

  render() {
    if (this.props.clearForm) {
      this.props.dispatch(reset(FORM_NAME));
      this.props.onClearForm();
    }

    const { handleSubmit } = this.props;

    return (
      <form onSubmit={handleSubmit(props => this.onSubmit(props))}>
        <div className="modal-section">
          <EmailField
            onEmailChange={this.onEmailChange}
          />
          {this.renderPasswordField()}
        </div>
        {this.renderSubmitButton()}
      </form>
    );
  }
}

const validate = (values, props) => {
  const { intl: { formatMessage } } = props;
  const errors = {};

  if (!values.email) {
    errors.email = formatMessage(i18n.badEmail);
  }

  if (!values.password) {
    errors.password = formatMessage(i18n.badPassword);
  }

  return errors;
};

export default injectIntl(reduxForm({
  validate,
  form: FORM_NAME,
})(SigninModalForm));



// WEBPACK FOOTER //
// ./src/desktop/components/signin-modal/signin-modal-form.js